import httpClient from '../../HttpClient';
import HttpPGAdapter from './HttpPGAdapter';
const PGAdapterBuilder = (keycloakIDPAdapter, apiUrl) => {
  return new HttpPGAdapter(keycloakIDPAdapter, httpClient, apiUrl);
};
export default PGAdapterBuilder;